import styled from 'styled-components';
import defaultTheme from '../theme';

const Button = styled.span`
  margin: 5px !important;
  cursor: pointer ;
  font-size:${({theme}) => theme.headerFontSize} !important ;
  color: #ffffff !important ;
  border: 0px;
  border-radius: ${({theme}) => (parseInt(theme.headerFontSize)+20)/2 + 'px'} !important;
  padding: 10px 10px !important;
  background: #1A73E9 !important;
  display: inline-block;
  line-height: 1;
  &:hover{
    opacity: 0.7;
  }
  
`;

Button.defaultProps = {
    theme: defaultTheme,
};

export default Button;
